module.exports = __webpack_public_path__ + "img/pp.64b07802.jpg";